module.exports = __webpack_public_path__ + "img/palm-room-3.79ecec4c.jpg";